import { render, staticRenderFns } from "./FieldDetails.vue?vue&type=template&id=55184146&scoped=true&"
import script from "./FieldDetails.vue?vue&type=script&lang=ts&"
export * from "./FieldDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FieldDetails.vue?vue&type=style&index=0&id=55184146&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55184146",
  null
  
)

export default component.exports